module.exports = __webpack_public_path__ + "static/media/Pulse Module 4.67876a45.jpg";